import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['source', 'actionText'];
  copy(event) {
    event.preventDefault();
    this.sourceTarget.select();
    document.execCommand('copy');
    this.actionTextTarget.innerText = 'Copied';
    setTimeout(() => {
      this.actionTextTarget.innerText = 'Copy';
    }, 500);
  }
}
